<template>
  <div>
    <!-- Short dispatch -->
    <modal
      :title="$t('OrderCurrent.actions.shortDispatch')"
      @close-request="reinitializeModal();"
      closable
      >

      <table-element
        :title="$t('OrderCurrent.modal.selected_orders')"
        :fields="fieldsObj"
        :arrOfElement="arrOfOrder"
        :sortSpacing="2"
        :isShowFilter="false"
        class="card mx-2 mt-4"
      >
        <template #header-actions>
          <p class="text-center red-text"><i class="fa fa-exclamation mr-2"></i><i>{{$t('OrderCurrent.modal.short_dispatch.process_tooltip')}}</i></p>
          <p class="mb-0 mt-3 mx-2">{{$t('OrderCurrent.count')}} {{arrOfOrder.length}}</p>
        </template>

        <template #pre-body-content>
          <regular-datalist-driver
            key="driver"
            :value="dispatchOrder.chauffeurName"
            @input="dispatchOrder.chauffeurName = $event.value; dispatchOrder.chauffeurUid = $event.key; setFeedbackMessage('')"
            :secondList="liste"
            :placeholder="$t('OrderInfo.modal.driver') + '*'" class="form-group border m-2"/>
        </template>

        <template #body-content-desktop="content">
          <!-- List of orders -->
          <tr v-for="(order, index) in content.results"
          class="table-element_hover text-center"
          :id="'order' + index"
          :key="'order' + index">
            <td v-if="checkHistory(order.historySync)"> <button class="btn btn-kne-green" :id="'dropDate' + order[index]"><i class="fa fa-solid fa-calendar-check"></i></button> </td>
            <td v-else> <button class="btn btn-kne-red" @click="onChangeDropDate(order); setFeedbackMessage('')"><i class="fa fa-solid fa-calendar"></i> {{$t('DeliveryLocationModal.drop_date_button')}}</button> </td>
            <td>
              <button class="btn btn-kne-orange" @click="onChangeAddress(order)"><i class="fas fa-edit"></i> {{$t('DeliveryLocationModal.address_button')}}</button>
            </td>
            <td v-if="isOrderNbClickable">
              <strong
                  @click="onOrderNumberView()"> 
                <router-link :to="{
                  name: 'OrderInfo',
                  query: {orderId: order.orderNumber}}"
                  target="_blank">
                  {{order.orderNumber}}
                </router-link>
              </strong>
            </td>
            <td v-else>
              {{order.orderNumber}}
            </td>
            <td>
              <span class="nowrap table-fix-width">{{shortenString(order.transmitterName)}}
                <hover-tool-tip
                  :text="`${order.transmitterAddress}
                          ${order.transmitterCity},
                          ${order.transmitterProvince}
                          ${order.transmitterPostcode},
                          ${order.transmitterCountry}`"
                  :top="true"
                  :right="true"
                  :clickable="true"
                />
              </span>
            </td>
            <td>
              <span class="nowrap table-fix-width">{{shortenString(order.receiverName)}}
                <hover-tool-tip
                  :text="`${order.receiverAddress}
                          ${order.receiverCity},
                          ${order.receiverProvince}
                          ${order.receiverPostcode},
                          ${order.receiverCountry}`"
                  :top="true"
                  :left="true"
                  clickable
                />
              </span>
            </td>
            <td>
              <regular-input-number
              v-show="!isBrunoAccount"
              min="0"
              :value="order.price"
              @input="order.price = $event"
              type="number" :placeholder="$t('OrderInfo.modal.price')"/>
              <regular-input-number
              v-show="isBrunoAccount"
              :id="'price' + order.orderNumber"
              min="0"
              :value="order.price"
              @input="order.price = $event"
              type="number" :placeholder="(calculateMaxInputPrice(order)) + '$ Max'"/>
            </td>
            <td>
              <regular-input
              min="0"
              :value="order.numRef"
              @input="order.numRef = $event"
              type="text" :placeholder="$t('OrderInfo.modal.reference')"/>
            </td>
            <td>
              <regular-input
              :value="order.comment"
              @input="order.comment = $event"
              type="text" :placeholder="$t('OrderCurrent.taxescomment')"/>
            </td>
          </tr>
        </template>

        <template #body-content-mobile="content">
          <!-- List of orders -->
          <div v-for="(order, index) in content.results"
          class="card my-3 mx-2"
          :key="index">
            <div class="card-header">
            <h4 v-if="isOrderNbClickable">
              <strong
                  @click="onOrderNumberView()"> 
                <router-link :to="{
                  name: 'OrderInfo',
                  query: {orderId: order.orderNumber}}"
                  target="_blank">
                  {{order.orderNumber}}
                </router-link>
              </strong>
            </h4>
            <h4 v-else>
              {{order.orderNumber}}
            </h4>

              <div id="action" class="float-left">
                <p v-if="checkHistory(order.historySync)" class=""> <button class="btn btn-kne-green" :id="'dropDate' + order[index]"><i class="fa fa-solid fa-calendar-check"></i></button> </p>
                <p v-else class=""> <button class="btn btn-kne-red" @click="onChangeDropDate(order)"><i class="fa fa-solid fa-calendar"></i> {{$t('DeliveryLocationModal.drop_date_button')}}</button> </p>
                <button class="btn btn-kne-orange mx-1" @click="onChangeAddress(order)"><i class="fas fa-edit"></i> {{$t('DeliveryLocationModal.address_button')}}</button>
              </div>
            </div>

            <div>
              <p class="m-2">
                <span class="nowrap table-fix-width">{{shortenString(order.transmitterName)}}
                  <hover-tool-tip
                    :text="`${order.transmitterAddress}
                            ${order.transmitterCity},
                            ${order.transmitterProvince}
                            ${order.transmitterPostcode},
                            ${order.transmitterCountry}`"
                    :top="true"
                    :right="true"
                    :clickable="true"
                  />
                </span>
              </p>
              <p class="m-2">
                <span class="nowrap table-fix-width">{{shortenString(order.receiverName)}}
                  <hover-tool-tip
                    :text="`${order.receiverAddress}
                            ${order.receiverCity},
                            ${order.receiverProvince}
                            ${order.receiverPostcode},
                            ${order.receiverCountry}`"
                    :top="true"
                    :left="true"
                    clickable
                  />
                </span>
              </p>
              <p class="m-2">
                <regular-input
                v-show="!isBrunoAccount"
                min="0"
                :value="order.price"
                @input="order.price = $event"
                type="number" :placeholder="$t('OrderInfo.modal.price')"/>

                <regular-input
                v-show="isBrunoAccount"
                :id="'price' + order.orderNumber"
                min="0"
                :value="order.price"
                @input="order.price = $event"
                type="number" :placeholder="(calculateMaxInputPrice(order)) + '$ Max'"/>
              </p>
              <p class="m-2">
                <regular-input
                min="0"
                :value="order.numRef"
                @input="order.numRef = $event"
                type="text" :placeholder="$t('OrderInfo.modal.reference')"/>
              </p>
              <p class="m-2">
                <regular-input
                :value="order.comment"
                @input="order.comment = $event"
                type="text" :placeholder="$t('OrderCurrent.taxescomment')"/>
              </p>
            </div>
          </div>
        </template>

        <template #post-body-content>
          <div class="mt-2">
            <p class="red-text mb-0 mx-1 text-right">{{ feedbackMessage }}</p>
            <button
              class="float-right btn btn-kne-orange m-1"
              @click="onShortDispatchActionConfirm()">
              {{$t('OrderCurrent.modal.confirm')}}
            </button>
            <button @click="reinitializeModal()" class="float-right btn btn-danger m-1">{{$t('OrderCurrent.modal.cancel')}}</button>
          </div>
        </template>
      </table-element>

      <loading-render v-if="isLoading" />
    </modal>

    <!-- Distributed History -->
    <distributed-history-modal
      key="distributed"
      ref="distModal"
      :isOpen="isDistributedModal"
      :priceOrderLink="priceOrderLink"
      @updateOrderInSelectedFull="(orderId, historyKey, order) => updateOrderInSelectedFull(orderId, historyKey, order)"
      @closeModal="isDistributedModal = false"
      @onOrderModification="onOrderModification"
    />

    <!-- Delivery Location -->
    <delivery-location-modal
      ref="delivLocDetails"
      :addressbook="addressbook"
      :showBilling="false"
      :isOpen="isDelivLocModal"
      @emitNewOrderLocation="updateOrderLocation"
      @closeModal="isDelivLocModal = false"
    />
  </div>
</template>

<script>
import Modal from '../../interface-components/Modal.vue'
import RegularInput from '../../basic-components/regularInput.vue'
import RegularInputNumber from '../../basic-components/regularInputNumber.vue'
import regularDatalistDriver from '../../basic-components/regularDatalistDriver.vue'
import HoverToolTip from '../../basic-components/HoverToolTip.vue'
import DistributedHistoryModal from './DistributedHistory-modal.vue'
import DeliveryLocationModal from './DeliveryLocation-modal.vue'
import TableElement from '../Table-component/Table-Element.vue'
import LoadingRender from '../Other-components/LoadingRender.vue'

import { db } from '../../../../firebase'

export default {
  name: 'ShortDispatchModal',
  components: {
    Modal,
    RegularInput,
    RegularInputNumber,
    regularDatalistDriver,
    HoverToolTip,
    DistributedHistoryModal,
    DeliveryLocationModal,
    TableElement,
    LoadingRender
  },

  props: {
    arrOfOrder: {
      type: Array,
      required: true
    },
    liste: {
      type: Array,
      required: true
    },
    addressbook: {
      type: Array,
      required: true
    },
    priceOrderLink: {
      type: Array,
      required: true
    },
    isOrderNbClickable: {
      type: Boolean,
      required: false
    },
    isOpen: Boolean
  },

  data () {
    return {
      dispatchOrder: {
        chauffeurUid: '',
        chauffeurName: ''
      },
      feedbackMessage: '',
      isDelivLocModal: false,
      isDistributedModal: false,
      fieldsObj: [
       {
         text: this.$t('OrderCurrent.order'),
         type: 'orderNumber',
         value: ''
       },
       {
         text: this.$t('OrderInfo.modal.pickup.title'),
         type: 'transmitterName',
         value: ''
       },
       {
         text: this.$t('OrderInfo.modal.delivery.title'),
         type: 'receiverName',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.price'),
         type: 'price',
         value: ''
       },
       {
         text: this.$t('OrderInfo.modal.reference'),
         type: 'numRef',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.taxescomment'),
         type: 'comment',
         value: ''
       }
      ]
    }
  },

  created () {
    this.isLoading = false
  },

  methods: {
    onOrderNumberView () {
      this.setFeedbackMessage(this.$t('ShortDispatch.reopen_window_alert'))
    },

    /** When the user wants to change the address, set the order with the @ref */
    onChangeAddress (order) {
      const delivRef = this.$refs.delivLocDetails

      delivRef.setOrder(order)
      this.isDelivLocModal = true
    },

    /** Updates the location of an order in the @arrOfOrder array after the user changes and saves the location in DeliveryLocationModal */
    updateOrderLocation (updatedOrder, isApplyToAllTransmitter, isApplyToAllReceiver) {
      if (isApplyToAllTransmitter) {
        this.arrOfOrder.forEach(order => {
          order.transmitterName = updatedOrder.transmitterName
          order.transmitterAddress = updatedOrder.transmitterAddress
          order.transmitterPostcode = updatedOrder.transmitterPostcode
          order.transmitterCity = updatedOrder.transmitterCity
          order.transmitterProvince = updatedOrder.transmitterProvince
          order.transmitterCountry = updatedOrder.transmitterCountry
        })
      }

      if (isApplyToAllReceiver) {
        this.arrOfOrder.forEach(order => {
          order.receiverName = updatedOrder.receiverName
          order.receiverAddress = updatedOrder.receiverAddress
          order.receiverPostcode = updatedOrder.receiverPostcode
          order.receiverCity = updatedOrder.receiverCity
          order.receiverProvince = updatedOrder.receiverProvince
          order.receiverCountry = updatedOrder.receiverCountry
        })
      }

      let indexOfOrder = this.arrOfOrder.findIndex(originalOrder => (originalOrder.orderNumber || originalOrder['.key']) === updatedOrder.orderNumber || updatedOrder['.key'])
      this.$set(this.arrOfOrder, indexOfOrder, updatedOrder)
    },

    /** Updates the order in @arrOfOrder so the button in ShortDispatch gets updated for UX purposes */
    updateOrderInSelectedFull (orderId, historyKey, updatedOrder) {
      this.arrOfOrder.find((originalOrder, index) => {
        if (originalOrder.orderNumber === orderId) {
          this.arrOfOrder[index].historySync[historyKey] = updatedOrder
        }
      })
    },

    /** When @dropDate or @isCancelled doesn't exist in the last history key, allow the user to set the @dropDate or @isCancelled to the last history key */
    onChangeDropDate (order) {
      const distModalRef = this.$refs.distModal

      const keys = distModalRef.getObjectKeys(order.historySync)
      const lastKey = distModalRef.getLastArrayData(keys)

      distModalRef.setOrder(order)
      distModalRef.setOrderId(order.orderNumber)
      distModalRef.setHistoryKey(lastKey)

      this.isDistributedModal = true
    },

    /** Used to set the red (false) or green (true) buttons in Short Dispatch */
    checkHistory (history) {
      const isTruthy = this.$refs.distModal.checkHistory(history)
      return isTruthy
    },

    setFeedbackMessage (message) {
      this.feedbackMessage = message
    },

    onShortDispatchActionConfirm () {
      if (!this.dispatchOrder.chauffeurUid) {
        this.setFeedbackMessage(this.$t('OrderCurrent.modal.short_dispatch.driver_not_selected_error'))
        return
      }

      if (!this.isDropDateFilled()) {
        this.setFeedbackMessage(this.$t('OrderCurrent.modal.short_dispatch.drop_date_error'))
        return
      }

      if (this.isBrunoAccount) {
        if (!this.checkDispatchPrice()) return
      }

      this.shortDispatchAction()
    },

    isDropDateFilled () {
      let isGucci = true

      this.arrOfOrder.forEach(order => {
        if (!this.checkHistory(order.historySync)) isGucci = false
      })

      return isGucci
    },

    shortDispatchAction () {
      this.arrOfOrder.forEach((order, index) => {
        let orderNumber = order.orderNumber
        delete order.orderNumber

        // TODO: Do we want to save placeId/lat/long here?
        let dispatchOrder = {
          'chauffeur': this.dispatchOrder.chauffeurUid,
          'chauffeurName': this.dispatchOrder.chauffeurName,
          'nbDispatch': order.nbDispatch,
          'comment': order.comment,
          'numRef': order.numRef,
          'price': order.price || 0,
          'receiver': order.receiverName,
          'receiverAddress': order.receiverAddress,
          'receiverCity': order.receiverCity,
          'receiverContact': order.receiverContact,
          'receiverFax': order.receiverFax,
          'receiverName': order.receiverName,
          'receiverPhone': order.receiverPhone,
          'receiverEmail': order.receiverEmail || '',
          'receiverPostcode': order.receiverPostcode || '',
          'receiverProvince': order.receiverProvince || '',
          'receiverCountry': order.receiverCountry,
          'transmitter': order.transmitterName,
          'transmitterAddress': order.transmitterAddress,
          'transmitterCity': order.transmitterCity,
          'transmitterContact': order.transmitterContact,
          'transmitterFax': order.transmitterFax,
          'transmitterName': order.transmitterName,
          'transmitterPhone': order.transmitterPhone,
          'transmitterEmail': order.transmitterEmail || '',
          'transmitterPostcode': order.transmitterPostcode || '',
          'transmitterProvince': order.transmitterProvince || '',
          'transmitterCountry': order.transmitterCountry || '',
          'dateDispatch': this.getDate(Date.now())
        }

        this.dbPushSet(dispatchOrder, orderNumber)
      })

      this.clearSelected()
      this.reinitializeModal()
    },

    async dbPushSet (dispatchOrder, orderNumber) {
      await db.ref('test/transporter/' + this.companyUID + '/newDispatch/' + orderNumber).push().set(dispatchOrder)
      await this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'FAST_DISPATCH', 'orderID': orderNumber, 'date': Date.now()}) // ADD FAST DISPATCH LOG
    },

    onOrderModification () {
      this.$emit('onOrderModification')
    },

    /** Calculates the price the user can input in the price field (Order price - all previous dispatch prices) */
    calculateMaxInputPrice (order) {
      let orderNumber = (order.orderNumber) ? order.orderNumber : order['.key']
      let currentOrder = this.priceOrderLink.find(obj => obj.orderId === orderNumber)

      const history = order.historySync
      let orderMaxPrice = Number(currentOrder.price)

      if (order.priceTransfered) {
        orderMaxPrice = orderMaxPrice - order.priceTransfered
      }

      for (const historyId in history) {
        if (Object.hasOwnProperty.call(history, historyId)) {
          const historyInfo = history[historyId]
          orderMaxPrice = orderMaxPrice - Number(historyInfo.price || historyInfo.prix || 0)
        }
      }

      return orderMaxPrice.toFixed(2) || 0
    },

    /** Validates if the entered price input is within the price of the order itself (Lower or equal to the order price) */
    checkDispatchPrice () {
      let index = 0
      let isAllGood = true
      let tempState = true

      this.arrOfOrder.forEach((order, i) => {
        tempState = this.evaluatePriceInput(this.arrOfOrder[index], order.price, this.priceOrderLink[index])
        index += 1
        if (!tempState) isAllGood = false
      })

      return isAllGood
    },

    evaluatePriceInput (order, priceInput, maxPriceOrderLink) {
      let maxOrderId = maxPriceOrderLink.orderId
      const orderNumber = order.orderNumber

      if (orderNumber !== maxOrderId) {
        console.log('Error, order mismatch', order, orderNumber, maxOrderId)
        return
      }

      let maxPrice = this.calculateMaxInputPrice(order)
      priceInput = Number(parseFloat(priceInput).toFixed(2))

      if (priceInput === '' || isNaN(priceInput)) {
        this.setPriceOrderClass(orderNumber, maxPrice, 'price/no-input')
        return false
      } else if (priceInput < 0) {
        this.setPriceOrderClass(orderNumber, maxPrice, 'price/no-negative')
        return false
      } else if ((maxPrice === 0 || maxPrice === '' || typeof maxPrice === 'undefined') && priceInput <= 0) {
        this.setPriceOrderClass(orderNumber, maxPrice, 'price/no-max-price')
        this.updateOrderPrice(order, priceInput, orderNumber) // Updates the order's price because we never actually touch the order's price
        return true
      } else if (priceInput > maxPrice) {
        this.setPriceOrderClass(orderNumber, maxPrice, 'price/too-high')
        return false
      } else if (priceInput !== '' && priceInput <= maxPrice) {
        this.setPriceOrderClass(orderNumber, maxPrice, 'price/perfect')
        this.updateOrderPrice(order, priceInput, orderNumber) // Updates the order's price because we never actually touch the order's price
        return true
      } else console.log('wtf', priceInput, maxPrice)
    },

    setPriceOrderClass (orderNumber, maxPrice, caseType) {
      switch (caseType) {
        case 'price/no-input':
          console.log('No price', orderNumber)
          document.getElementById('price' + orderNumber).className += ' red-border '
          this.feedbackMessage = this.$t('OrderCurrent.order') + ' #' + orderNumber + this.$t('OrderCurrent.modal.dispatch.no_price')
          break

        case 'price/no-negative':
          console.log('No negative price')
          document.getElementById('price' + orderNumber).className += ' red-border '
          this.feedbackMessage = this.$t('OrderCurrent.order') + ' #' + orderNumber + this.$t('OrderCurrent.modal.dispatch.no_negative')
          break

        case 'price/too-high':
          console.log('Input is higher', maxPrice)
          document.getElementById('price' + orderNumber).className += ' red-border '
          this.feedbackMessage = this.$t('OrderCurrent.order') + ' #' + orderNumber + this.$t('OrderCurrent.modal.dispatch.too_high') + ' (Max: ' + (maxPrice || 0) + '$)'
          break

        case 'price/no-max-price':
          console.log('No max price', maxPrice)
          document.getElementById('price' + orderNumber).className += ' green-border '
          break

        case 'price/perfect':
          console.log('Good price', maxPrice)
          document.getElementById('price' + orderNumber).className += ' green-border '
          break

        default:
          break
      }
    },

    updateOrderPrice (updatedOrder, priceInput, orderNumber) {
      if (updatedOrder.orderNumber !== orderNumber) console.log('error')
      else {
        this.arrOfOrder.find((order, index) => {
          if (order.orderNumber === orderNumber) {
            this.arrOfOrder[index].price = priceInput
          }
        })
      }
    },

    shortenString (text) {
      if (typeof text === 'undefined') return text
      else {
        let subString = text.substring(0, 22)
        if (text.length > 22) subString += '...'
        return subString
      }
    },

    getDate: function (timestamp) {
      var date = new Date(timestamp)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    },

    reinitializeModal () {
      this.dispatchOrder.chauffeurUid = ''
      this.dispatchOrder.chauffeurName = ''
      this.feedbackMessage = ''

      this.closeModal()
    },

    clearSelected () {
      this.$emit('clearSelected')
    },
    closeModal () {
      this.$emit('closeModal')
    }
  },

  computed: {
    companyUID () {
      return this.$store.state.authorization.company
    },

    uid () {
      return this.$store.state.user.uid
    }
  }
}
</script>

<style scoped>
  /* @media only screen and (max-width: 800px) {
    body {
      display: flex;
      flex-direction: column;
      color: red;
      background-color: red;
    }
  } */
</style>
